import React, { useContext, useState, useRef } from 'react'
import classNames from 'classnames'
import * as userAuth from 'meinian-package/src/utils/auth'
import Icon from 'meinian-package/src/component/icon'
import { QuickEdit } from 'component/imageDetail/info'
import { ImageDetailContext } from '../../content'
import Dynamic from './dynamic'
import InfoLabel from './label'
import InfoDetail from './detail'
import OriginalText from './originalText'
import InfoFooter from './footer'
import { getElement } from './label/element'
import type { IImageDetailContext } from '../../interface'
import styles from './index.module.less'

interface InfoProps {
  imgInfoList: Array<any>,
  hasZkOfficialStyle: boolean,
}

export default ({ imgInfoList, hasZkOfficialStyle }: InfoProps) => {
  const {
    currentImage,
    queryParams,
    boxIndex,
    onBoxIndex,
    upgradeInfo,
    onDeleteItem,
    onBanOperation,
    onInit
  } = useContext<IImageDetailContext>(ImageDetailContext)
  const dynamicRef = useRef(null)
  const elements = currentImage?.boxLabelRetList ? currentImage?.boxLabelRetList?.[boxIndex] || {} : {}
  const { show } = getElement(elements)
  const [visible, setVisible] = useState(false)
  const auth = currentImage.loginUserInfo?.inspirationPermissions || []

  const renderEditBtn = (node: React.JSX.Element) => <QuickEdit
    currentImage={upgradeInfo}
    blogId={queryParams.blogId}
    visible={visible}
    setVisible={setVisible}
    onDeleteItem={onDeleteItem}
    inspirationId={queryParams.inspirationId}
    setBanStatus={onBanOperation}
    boxIndex={boxIndex}
    onChange={() => {
      onInit()
    }}
  >
    {node}
  </QuickEdit>

  const renderStyleTitleText = () => {
    if (upgradeInfo?.styleTitle) {
      return <div style={{ marginTop: '12px', wordBreak: 'break-all', }}>
        {upgradeInfo?.styleTitle}
      </div>
    }

    if (!userAuth.isPermissions(auth, ['FS05', 'FS05_CREATOR', 'FCS06', 'FCS06_CREATOR']) || hasZkOfficialStyle) {
      return <div className={styles.infoStyleName}>
        款式名称
      </div>
    }
    return renderEditBtn(<div className={styles.infoStyleName}>
      <Icon type="m-bianji" style={{ marginRight: '4px' }} />点此添加款式名称
    </div>)
  }

  const renderStyleDescText = () => {
    if (upgradeInfo?.styleDesc) {
      return <div style={{ marginTop: '12px', wordBreak: 'break-all', }}>
        {upgradeInfo?.styleDesc}
      </div>
    }
    if (!userAuth.isPermissions(auth, ['FS05', 'FS05_CREATOR', 'FCS06', 'FCS06_CREATOR']) || hasZkOfficialStyle) {
      return <div className={styles.infoStyleName}>
        款式描述
      </div>
    }
    return renderEditBtn(<div className={styles.infoStyleName}>
      <Icon type="m-bianji" style={{ marginRight: '4px' }} />点此添加款式描述
    </div>)
  }

  return <>
    <div className={styles.mnImageDetailInfoViewContent}>
      {
        !hasZkOfficialStyle && <OriginalText currentImage={currentImage} />
      }
      <div className={classNames(styles.infoBlock, 'mt32')}>
        <div className={styles.titleLine}>
          <div className={styles.point} /><div className={styles.mainTitle}>款式名称</div>
          {
            upgradeInfo?.styleTitle && <div className={styles.mainTitleRight}>
              { !userAuth.isPermissions(auth, ['FS05', 'FS05_CREATOR', 'FCS06', 'FCS06_CREATOR']) || hasZkOfficialStyle ? null
                : renderEditBtn(<div className={classNames(styles['edit-info-btn'], 'fill-white-bg')}>
                  <Icon type="m-kuaisubianji" style={{ marginRight: 2, fontSize: '16px' }} />编辑
                </div>)}
            </div>
          }
        </div>
        {renderStyleTitleText()}
      </div>
      <div className={classNames(styles.infoBlock, 'mt32')}>
        <div className={styles.titleLine}>
          <div className={styles.point} /><div className={styles.mainTitle}>款式描述</div>
          {
            upgradeInfo?.styleDesc && <div className={styles.mainTitleRight}>
              { !userAuth.isPermissions(auth, ['FS05', 'FS05_CREATOR', 'FCS06', 'FCS06_CREATOR']) ? null
                : renderEditBtn(<div className={classNames(styles['edit-info-btn'], 'fill-white-bg')}>
                  <Icon type="m-kuaisubianji" style={{ marginRight: 2, fontSize: '16px' }} />编辑
                </div>)}
            </div>
          }
        </div>
        {renderStyleDescText()}
      </div>
      {
        show && <InfoLabel currentImage={currentImage} boxIndex={boxIndex} onBoxIndex={onBoxIndex} />
      }
      {
        userAuth.isPermissions(auth, ['FS16']) && !hasZkOfficialStyle && <div className={classNames(styles.infoBlock, 'mt32')}>
          <div className={styles.titleLine}>
            <div className={styles.point} /><div className={styles.mainTitle}>款式动态</div>
          </div>
          <div className={styles.infoBlockContext}>
            <Dynamic ref={dynamicRef} queryParams={queryParams} currentImage={currentImage} onBanOperation={onBanOperation} />
          </div>
        </div>
      }
      <InfoDetail currentImage={currentImage} queryParams={queryParams} hasZkOfficialStyle={hasZkOfficialStyle} />
    </div>
    <InfoFooter
      hasZkOfficialStyle={hasZkOfficialStyle}
      currentImage={currentImage}
      imgInfoList={imgInfoList}
      onInit={() => {
        dynamicRef.current?.onInit()
        onInit()
      }}
    />
  </>
}
